import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import {
  dictionaryCurrencyName,
  dictionaryCurrencySymbol
} from "../constants/currency";

export function getCurrencyOption(key: bankingApiSpec.Currency) {
  return {
    value: key,
    label: `${key} (${dictionaryCurrencySymbol[key]})`,
    labels: [dictionaryCurrencyName[key]]
  };
}
